import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import styles from './TicketDetail.module.css';

const TicketDetail = () => {
  const navigate = useNavigate();
  const [replyText, setReplyText] = useState('');
  const [activeTab, setActiveTab] = useState('reply');

  const headerBadge = <Badge variant="warning">Open</Badge>;

  const headerActions = (
    <Button
      variant="secondary"
      style={{ color: '#007A21' }}
      onClick={() => navigate('/support')}
    >
      Resolve ticket
    </Button>
  );

  return (
    <>
      <PageHeader
        backTo="/support"
        backText="← Support"
        title="TK-881 · Incentive not credited"
        badge={headerBadge}
        subtitle="Opened 2h ago by Sneha Patel (Participant) · Priority High"
        actions={headerActions}
      />

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Conversation thread</h2>

          <div className={styles.threadList}>
            <div className={styles.userMessage}>
              <div className={styles.msgHeader}>
                <span className={styles.msgAuthor}>Sneha Patel</span>
                <span>2 hours ago</span>
              </div>
              <div className={styles.msgBody}>
                Hi support, I attended the Mothers' Chocolate Perception focus group yesterday morning at 11am, but my ₹1000 incentive has not arrived in my UPI account yet. Can you please check?
              </div>
            </div>

            <div className={styles.supportMessage}>
              <div className={styles.msgHeader}>
                <span className={styles.supportAuthor}>Nishant K. (Support)</span>
                <span>1 hour ago</span>
              </div>
              <div className={styles.msgBody}>
                Hello Sneha! The researcher confirmed attendance at 3 PM today. Payout batch PB-0929 is scheduled for 6 PM today and your payout will be included.
              </div>
            </div>
          </div>

          <div className={styles.replySection}>
            <div className={styles.subTabGroup}>
              <button
                type="button"
                onClick={() => setActiveTab('reply')}
                className={`${styles.subTabBtn} ${activeTab === 'reply' ? styles.subTabBtnActive : ''}`.trim()}
              >
                Reply to user
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('note')}
                className={`${styles.subTabBtn} ${activeTab === 'note' ? styles.subTabBtnActive : ''}`.trim()}
              >
                Internal note
              </button>
            </div>
            <textarea
              placeholder="Type your message..."
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              className={styles.textareaField}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="primary">Send reply</Button>
            </div>
          </div>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Ticket attributes</h2>
          <div className={styles.attributeRow}>
            <span className={styles.attributeLabel}>Assignee</span>
            <span className={styles.attributeValue}>Nishant K.</span>
          </div>
          <div className={styles.attributeRow}>
            <span className={styles.attributeLabel}>Related study</span>
            <span className={styles.attributeValue}>Mothers' Chocolate</span>
          </div>
          <div className={styles.attributeRow}>
            <span className={styles.attributeLabel}>Payout status</span>
            <span className={`${styles.attributeValue} ${styles.warningValue}`}>Queued in PB-0929</span>
          </div>
        </section>
      </div>
    </>
  );
};

export default TicketDetail;
